export default __webpack_public_path__ + "static/media/EAR-INFECTION.eefbc250.png";